import { Box, Heading, Stack, useTheme } from "@chakra-ui/react";
import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import BackButton from "../../components/BackButton";
import HybridBottomSheetDrawer from "../../components/HybridBottomSheetDrawer";
import OutletCard from "../../components/outlets/OutletCard";
import QueryStateWrapper from "../../components/QueryStateWrapper";
import { useOutlets } from "../../data/outlets.api";
import { useFocusOnPoints } from "../../hooks/useFocusOnPoints";

const AllOutlets = () => {
  const { data, isLoading, error, isSuccess } = useOutlets();
  const navigate = useNavigate();
  const theme = useTheme();

  const points = useMemo(() => {
    if (data) {
      return data
        .filter((outlet) => outlet.longitude && outlet.latitude)
        .map((outlet) => ({
          lat: outlet.latitude,
          lng: outlet.longitude,
          onClick: () => navigate(`/outlets/${outlet.businessID}`),
          color: outlet.isOpen
            ? theme?.colors?.["green"]?.["500"]
            : theme?.colors?.["lancsRed"]?.["300"],
        }));
    }
    return [];
  }, [data, navigate, theme?.colors]);

  useFocusOnPoints(points);

  return (
    <HybridBottomSheetDrawer>
      <BackButton />

      <Box p={8}>
        <Heading size="md" mb={4}>
          Outlets
        </Heading>
        <QueryStateWrapper isLoading={isLoading} error={error} data={data}>
          <Box mb={8}>
            <Heading size="sm" mb={2}>
              Open Now
            </Heading>
            <Stack>
              {data
                ?.filter((outlet) => outlet.isOpen)
                .map((outlet) => (
                  <OutletCard outlet={outlet} />
                ))}
            </Stack>
          </Box>
          <Box mb={2}>
            <Heading size="sm" mb={2}>
              Closed
            </Heading>
            <Stack>
              {data
                ?.filter((outlet) => !outlet.isOpen)
                .map((outlet) => (
                  <OutletCard outlet={outlet} />
                ))}
            </Stack>
          </Box>
        </QueryStateWrapper>
      </Box>
    </HybridBottomSheetDrawer>
  );
};

export default AllOutlets;
